import React, { useEffect } from 'react';
import RegistrationForm from './RegistrationForm';
import { Toaster } from './ui/toaster';

const RegistrationPage = () => {
  // Override the global desktop-only viewport for this page only — make it mobile-friendly.
  // Also set a SEO-friendly page title + description scoped to this route, and hide
  // the global "Made with Emergent" badge on this page only.
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    const originalViewport = meta ? meta.getAttribute('content') : null;
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=5');
    }
    const originalTitle = document.title;
    document.title = 'Register Unifi Online | High Speed Internet Malaysia';

    // Override description for this route
    const descMeta = document.querySelector('meta[name="description"]');
    const originalDesc = descMeta ? descMeta.getAttribute('content') : null;
    const pageDesc = 'Register Unifi online in minutes! Enjoy high-speed internet with fast installation at your doorstep. Easy sign-up, no hassle. Get started today!';
    if (descMeta) descMeta.setAttribute('content', pageDesc);

    // Hide the emergent badge on this route
    const badge = document.getElementById('emergent-badge');
    const originalBadgeDisplay = badge ? badge.style.display : null;
    if (badge) badge.style.display = 'none';

    return () => {
      if (meta && originalViewport) meta.setAttribute('content', originalViewport);
      document.title = originalTitle;
      if (descMeta && originalDesc) descMeta.setAttribute('content', originalDesc);
      if (badge) badge.style.display = originalBadgeDisplay || '';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-white">
      {/* Mobile-friendly top bar */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2" data-testid="reg-page-home-link">
            <img
              src="/images/brand/unifi.svg"
              alt="Unifi"
              className="h-8 sm:h-10"
            />
          </a>
          <a
            href={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP_PHONE}&text=I%27m%20interested%20UniFi%20Service`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-white bg-[#25D366] hover:bg-[#1ebe57] px-3 py-1.5 rounded-full"
            data-testid="reg-page-whatsapp"
          >
            WhatsApp
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-6 sm:py-10">
        <RegistrationForm mode="page" />
      </main>

      <footer className="text-center text-xs text-gray-500 py-6 px-4">
        Unifi. All rights reserved.
      </footer>

      <Toaster />
    </div>
  );
};

export default RegistrationPage;
